import { render, staticRenderFns } from "./top-bar.vue?vue&type=template&id=2e75ef24&"
import script from "./top-bar.vue?vue&type=script&lang=js&"
export * from "./top-bar.vue?vue&type=script&lang=js&"
import style0 from "./top-bar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e75ef24')) {
      api.createRecord('2e75ef24', component.options)
    } else {
      api.reload('2e75ef24', component.options)
    }
    module.hot.accept("./top-bar.vue?vue&type=template&id=2e75ef24&", function () {
      api.rerender('2e75ef24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/header/top-bar/top-bar.vue"
export default component.exports